import { render, staticRenderFns } from "./IssueTrackerDashboard.vue?vue&type=template&id=118b9efc&scoped=true"
import script from "./IssueTrackerDashboard.vue?vue&type=script&lang=js"
export * from "./IssueTrackerDashboard.vue?vue&type=script&lang=js"
import style0 from "./IssueTrackerDashboard.vue?vue&type=style&index=0&id=118b9efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118b9efc",
  null
  
)

export default component.exports